// Arabic strings for the redesigned Promotions analytics workspace
// (components/Reports/PromotionsWorkspace).
const trans = {
  // Tabs + page chrome
  "Coupon Usage": "استخدام الكوبونات",
  "Promotion Orders": "طلبات العروض",
  "Promotion performance, usage and discount impact.": "أداء العروض واستخدامها وأثر الخصومات.",
  "Promotion ROI, basket uplift, acquisition and per-promo effectiveness.":
    "عائد العروض وزيادة قيمة السلة واكتساب العملاء وفعالية كل عرض.",
  "Exactly who used each coupon or promotion.": "من استخدم كل كوبون أو عرض بالتحديد.",
  "Orders that used a promotion or coupon.": "الطلبات التي استخدمت عرضًا أو كوبونًا.",

  // Pulse KPIs + hints
  "Revenue from promos": "الإيرادات من العروض",
  "Sales from orders that used a promo": "المبيعات من الطلبات التي استخدمت عرضًا",
  "Discount given": "الخصم الممنوح",
  "Total value handed back as discounts": "إجمالي القيمة المُعادة كخصومات",
  "Discount rate": "معدل الخصم",
  "Discount as a share of promo revenue": "الخصم كنسبة من إيرادات العروض",
  Penetration: "معدل الانتشار",
  "Share of all orders that used a promo": "نسبة جميع الطلبات التي استخدمت عرضًا",
  Redemptions: "الاستخدامات",
  "Promo and coupon redemptions in the period": "استخدامات العروض والكوبونات خلال الفترة",

  // Pulse panels
  "Basket uplift": "زيادة قيمة السلة",
  "Avg order value with vs without a promo": "متوسط قيمة الطلب مع وبدون عرض",
  promoted: "بعرض",
  "non-promoted": "بدون عرض",
  "larger basket on promo orders": "سلة أكبر في طلبات العروض",
  "smaller basket on promo orders": "سلة أصغر في طلبات العروض",
  "Who's redeeming": "من يستفيد من العروض",
  "New vs existing customers": "العملاء الجدد مقابل الحاليين",
  "goes to existing customers — watch for cannibalization":
    "تذهب إلى العملاء الحاليين — انتبه لتآكل المبيعات",
  "Promotion scorecard": "بطاقة أداء العروض",
  "Click a promo to drill into its redemptions": "اضغط على عرض للاطّلاع على استخداماته",
  Promotion: "العرض",
  Usage: "الاستخدام",
  Rate: "النسبة",
  "New %": "% الجدد",

  // Coupon usage / orders tables
  "Coupon/promotion": "الكوبون/العرض",
  "Usage count": "عدد الاستخدامات",
  "Date used": "تاريخ الاستخدام",
  "Order amount": "قيمة الطلب",
  Coupon: "الكوبون",
  "Show all coupons": "عرض كل الكوبونات",
  "Showing customers for": "عرض عملاء",
};

export default trans;
